import { render, staticRenderFns } from "./AgreementContext.vue?vue&type=template&id=1b24159a&scoped=true&"
import script from "./AgreementContext.vue?vue&type=script&lang=ts&"
export * from "./AgreementContext.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b24159a",
  null
  
)

export default component.exports